import "./topbar.scss";
import Buttons from "./Buttons";

export default function Topbar() {
    const handleClick = (el) => {
        try{
            document.getElementById("navbarTop").getElementsByClassName("active")[0].classList.remove('active')
            el.target.classList.add('active')
        }
        catch(e){}
        if(document.querySelectorAll('.nav-wrapper.collapse.show').length === 1){
            document.getElementById("navbar-toggler").click();
        }
    }

    return (
        <>
            <nav className="topbar navbar navbar-expand-sm navbar-dark show-sm" id="navbarSmContainer">
                <div className="container show-sm" id="collapse-buttons">
                    <a className="navbar-toggler position-relative collapsed" id="navbar-toggler" href="#navbarTop" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTop" aria-controls="navbarTop" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </a>
                    <a className="navbar-brand position-relative" href="#home" onClick={() => handleClick()}>
                        <img className="img-logo img-responsive" src="/images/logos/jk-logo-navbar.svg" alt="logo" width="40px" height="auto"/>
                    </a>
                </div>
            </nav>
            <nav className="topbar navbar navbar-expand-sm navbar-dark" id="navbarTopContainer">
                <div className="collapse navbar-collapse nav-wrapper" id="navbarTop">
                    <div className="navbar-nav center">
                        <Buttons text="Home" className="active" href="home" handleClick={() =>handleClick}/>
                        <Buttons text="About" href="about" handleClick={() =>handleClick}/>
                        <Buttons text="Home" className="img-logo-container hide-sm" href="home" isImage="true" imgSrc="/images/logos/jk-logo-navbar.svg" handleClick={() =>handleClick}/>
                        <Buttons text="Projects" href="projects" handleClick={() =>handleClick}/>
                        <Buttons text="Contact" href="contact" handleClick={() =>handleClick}/>
                    </div>
                </div>
            </nav>
        </>
    )
}